import { getLuckyDraws } from "@/api/http";

export default {
  namespaced: true,

  state: {
    lots: [],
  },

  getters: {
    list(state) {
      return state.lots;
    },
  },

  actions: {
    async fetch({ commit }) {
      const params = {
        order_by:
          localStorage.getItem("luckydraw_order_by") || "earliest_start",
      };
      const { data } = await getLuckyDraws(params);
      commit("SET_LIST", data);
    },
  },

  mutations: {
    SET_LIST(state, payload) {
      state.lots = payload;
    },
  },
};
